import { Slider, SliderThumb, SliderMarkLabel, SliderMark } from "@mui/material";
import { useEffect, useState } from "react";
import styled from "styled-components";
import IconFace1 from "../../../assets/images/icon-face-1.svg"
import IconFace2 from "../../../assets/images/icon-face-2.svg"
import IconFace3 from "../../../assets/images/icon-face-3.svg"
import IconFace4 from "../../../assets/images/icon-face-4.svg"
import IconFace5 from "../../../assets/images/icon-face-5.svg"

const Container = styled.div`
    width: 100%;
    height: 80px;
    margin-top: 12px;
`;

const SliderBox = styled(Slider)(() => ({
    width: "calc(100% - 60px) !important",
    height: 4,
    color: '#FFFFFF00 !important',
    '& .MuiSlider-thumb': {
        height: 32,
        width: 32,
        backgroundColor: '#FFFFFF',
        border: '0px',
        '&:hover': {
            boxShadow: '0 0 0 8px rgba(248,244,218,0.6)',
        },
    },
    '& .MuiSlider-track': {
        color: "#FFFFFF00",
        height: 0,
    },
    '& .MuiSlider-rail': {
        backgroundImage: "linear-gradient(90deg, rgba(143,236,234,1) 0%, rgba(251,226,80,1) 100%)",
        opacity: 1,
        height: 6,
    },
    '& .MuiSlider-mark': {
        height: 10,
        width: 10,
        borderRadius: "50%",
        backgroundColor: '#8FECEA',
    },
}));

function ThumbComponent(props, value) {
    const { children, ...other } = props;
    return (
        <SliderThumb {...other}>
            {children}
            {value === 1 && <img src={IconFace1} />}
            {value === 2 && <img src={IconFace2} />}
            {value === 3 && <img src={IconFace3} />}
            {value === 4 && <img src={IconFace4} />}
            {value === 5 && <img src={IconFace5} />}
        </SliderThumb>
    );
}

function MarkComponent(props) {
    const { children, ...other } = props;
    return (
        <SliderMark {...other}>
        </SliderMark>
    );
}

function MarkLabelComponent(props) {
    const { children, ...other } = props;
    return (
        <SliderMarkLabel {...other}>
            <div className="content-center" style={{ display: "flex", flexDirection: "column" }}>
                <div style={{
                    color: "#505050",
                    fontSize: "14px",
                    fontWeight: "300",
                    lineHeight: "20.93px",
                }}>
                    {children === "1" && "น้อยที่สุด"}
                    {children === "2" && "น้อย"}
                    {children === "3" && "ปานกลาง"}
                    {children === "4" && "มาก"}
                    {children === "5" && "มากที่สุด"}
                </div>
                {children}
            </div>
        </SliderMarkLabel>
    );
}

function Rating5Component({
    value,
    disable,
    labelError,
    isError,
    onSelect,
}) {
    const [valueRating, setValueRating] = useState(0);
    const marks = [
        { value: 1, label: '1', },
        { value: 2, label: '2', },
        { value: 3, label: '3', },
        { value: 4, label: '4', },
        { value: 5, label: '5', },
    ];

    useEffect(() => {
        setValueRating(value || 0)
    }, [value])

    function handleChange(param) {
        const _value = param.target.value;
        setValueRating(_value);
        onSelect && onSelect(_value)
    }

    return (
        <Container className="horizontal-center">
            <SliderBox
                slots={{
                    thumb: (props) => { return ThumbComponent(props, valueRating) },
                    mark: MarkComponent,
                    markLabel: MarkLabelComponent,
                }}
                step={1}
                min={1}
                max={5}
                valueLabelDisplay="auto"
                marks={marks}
                value={valueRating}
                disabled={disable}
                onChange={handleChange}
            />
        </Container>
    );
}

export default Rating5Component